<template>
    <AppPage title="Configurações" subtitle="Gerenciar as principais configurações do sistema">
        <form @submit.prevent="save">
            <b-field label="Aviso" message="Esta mensagem será exibida na página inicial do aplicativo">
                <b-input type="textarea" :rows="5" v-model="notice"/>
            </b-field>
            <b-field label="Mensagem de sucesso" message="Esta mensagem será exibida quando um pedido for realizado">
                <b-input type="textarea" :rows="5" v-model="successMessage"/>
            </b-field>
            <button type="submit" class="button is-primary is-rounded">Salvar</button>
        </form>
    </AppPage>
</template>

<script>

import {save, get} from '../conf.actions'
import AppPage from "../../../components/AppPage";

export default {
    name: "ConfPage",
    components: {AppPage},

    data() {
        return {
            notice: null,
            successMessage: null
        }
    },

    methods: {
        async save() {
            const loading = this.$buefy.loading.open();
            await save('notice', this.notice);
            await save('order-success', this.successMessage);

            loading.close();
        }
    },

    async created() {
        const loading = this.$buefy.loading.open();
        this.notice = await get('notice');
        this.successMessage = await get('order-success');

        loading.close();
    }
}
</script>
